'use client';

import { useEffect, useRef } from 'react';

import { useAlertBanner, useScrollToSection } from '@libs/common-next';
import { AlertBanner } from './AlertBanner';

export function AlertBannerContainer() {
    const { alert } = useAlertBanner();

    const elementRef = useRef<HTMLDivElement | null>(null);
    const scrollToSection = useScrollToSection();

    useEffect(() => {
        if (elementRef?.current && !alert?.skipScrollToAlert) {
            scrollToSection('alert-banner-container');
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps -- prevent re-render
    }, [alert]);

    return alert ? (
        <div
            ref={elementRef}
            className="alert-banner-container"
            id="alert-banner-container"
        >
            <AlertBanner
                header={alert.header}
                variant={alert.variant}
                iconName={alert?.icon}
                dismissible={alert?.dismissible}
            >
                {alert.text}
            </AlertBanner>
        </div>
    ) : null;
}
